export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const INSIGHTS_URL = `${process.env.REACT_APP_BACKEND_URL}/insights`;
export const ANALYTICS_URL = `${process.env.REACT_APP_BACKEND_URL}/analytics`;